import script from "./BookingSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSuccess.vue?vue&type=script&setup=true&lang=js"

import "./BookingSuccess.vue?vue&type=style&index=0&id=85b7c79e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85b7c79e"]])

export default __exports__